import { render, staticRenderFns } from "./StepTab1.vue?vue&type=template&id=b5f819b2&scoped=true"
import script from "./StepTab1.vue?vue&type=script&lang=js"
export * from "./StepTab1.vue?vue&type=script&lang=js"
import style0 from "./StepTab1.vue?vue&type=style&index=0&id=b5f819b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f819b2",
  null
  
)

export default component.exports